export default __webpack_public_path__ + "static/media/hiking.a9bd6218.jpg";